/**
 * 포인트 탭 컨텐츠 컴포넌트
 *
 * #454 시정: brand/store 단위 분리 표시 (PointsByBrandList).
 * groupedAccounts 미제공 시 기존 FranchiseBrandsList 만 노출 (호환).
 */
import { PointsSummaryCard } from './PointsSummaryCard';
import { OrganizationPointsOverview } from './OrganizationPointsOverview';
import { PointsGuide } from './PointsGuide';
import type { PointsData, PointsTranslations } from './types';
import type { PointsOrganizationSection } from '@/hooks/usePointsPortfolio';

interface PointsTabContentProps {
  pointsData: PointsData;
  translations: PointsTranslations;
  organizations: PointsOrganizationSection[];
  highlightedBrandId?: string | null;
  highlightedStoreId?: string | null;
}

export function PointsTabContent({
  pointsData,
  translations,
  organizations,
  highlightedBrandId,
  highlightedStoreId
}: PointsTabContentProps) {
  return (
    <>
      <PointsSummaryCard pointsData={pointsData} />
      <OrganizationPointsOverview
        organizations={organizations}
        highlightedBrandId={highlightedBrandId}
        highlightedStoreId={highlightedStoreId}
      />
      <PointsGuide translations={translations} />
    </>
  );
}
